var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout"
  }, [_c('div', {
    staticClass: "s-container"
  }, [!_vm.initialized ? _c('p', {
    staticClass: "s-text-xl"
  }, [_vm._v("Initializing...")]) : !_vm.errorOccurred ? _c('router-view') : _vm._e()], 1), _c('Alert', {
    ref: "alert"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }